// extracted by mini-css-extract-plugin
export default {"root":"LanguageCompiliancePanel_root__ct87Q","button":"LanguageCompiliancePanel_button__15DW+"};